/**
 * Configuración global del frontend
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (window.location.hostname === 'localhost' 
    ? 'http://localhost:5002/cedet-api' 
    : '/cedet-api');

export default {
  API_BASE_URL
};
